<template>
    <div class="public">
        <cookie-bar></cookie-bar>

        <SimpleHeader />

        <main>
            <div class="structure">
                <back-to-home />
                <terms-of-use class="legal-content" />
                <div class="page-job-code">Job code: {{ $route.meta.jobCode }} | {{ dateOfPrep }}</div>
            </div>
        </main>
    </div>
</template>

<script>
import SimpleHeader from '@/components/layout/SimpleHeader.vue';
import BackToHome from '@/components/layout/BackToHome.vue';
import TermsOfUse from '@/components/legal/TermsOfUse.vue';

export default {
    name: 'PublicTermsPage',
    components: {
        BackToHome,
        SimpleHeader,
        TermsOfUse
    },
    data () {
        return {
            dateOfPrep: 'March 2023'
        };
    }
};
</script>
